// back to top
const back_to_top = $('.back-to-top');

back_to_top.addClass('hidden-top');

$(window).scroll(function () {
    if ($(this).scrollTop() === 0) {
        back_to_top.addClass('hidden-top');
    } else {
        back_to_top.removeClass('hidden-top');
    }
});

back_to_top.click(function () {
    $('body,html').animate({scrollTop: 0}, 1200);
    return false;
});

$(document).on('click', 'a.js-scroll', function (e) {
    const href = $(this).attr('href');
    const toggleNav = document.querySelector('.nav__icon');

    if (!href || !href.startsWith('#')) {
        return;
    }

    const target = document.querySelector(href);
    if (!target) {
        return;
    }

    e.preventDefault();

    if (toggleNav?.classList.contains('active')) {
        toggleNav.click();
    }

    if (window.lenis) {
        window.lenis.scrollTo(0, { duration: 1.2 });
        return;
    }

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});